import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Section from "@/components/section"

const ContentTabs = ({ dynamicTabData = {} }) => {
  const { tabs = [] } = dynamicTabData
  const [activeTab, setActiveTab] = useState(tabs?.[0]?.fields?.tabText)

  const handleTabChange = label => {
    setActiveTab(label)
  }
  const normalize = (text = "") =>
  text.toLowerCase().replace(/\s+/g, "");

  useEffect(() => {
    const handleTabChange = (e) => {
      const targetKey = e.detail;

      const matchedTab = tabs.find((tab) =>
        normalize(tab?.fields?.tabText) === normalize(targetKey)
      );

      if (matchedTab) {
        setActiveTab(matchedTab.fields.tabText);
      }
    };

    window.addEventListener("changeTab", handleTabChange);

    return () =>
      window.removeEventListener("changeTab", handleTabChange);
  }, [tabs]);

  return (
    <>
      {/* TABS */}
      <div className="flex w-full border-b border-[#FFFFFF] bg-[#212121] h-[50px] md:justify-center"  id="content-tabs">
        {tabs.map(
          tab =>
            tab?.fields?.tabText && (
              <button
                key={tab?.fields?.tabText}
                onClick={() => handleTabChange(tab?.fields?.tabText)}
                className={`
                  relative 
                  
                  /* MOBILE */
                  flex-1 text-center px-2
                  
                  /* DESKTOP */
                  md:flex-none md:px-[30px]

                  text-[12px] sm:text-[14px] md:text-[14px]
                  transition-colors duration-300

                  ${
                    activeTab === tab?.fields?.tabText
                      ? "text-white font-semibold"
                      : "text-[#ccc]"
                  }

                  after:content-[''] 
                  after:absolute after:left-0 after:bottom-0
                  after:h-[2px] after:w-0 after:bg-white
                  after:transition-all after:duration-300

                  hover:text-white hover:after:w-full

                  ${activeTab === tab?.fields?.tabText ? "after:w-full" : ""}
                `}
              >
                {tab?.fields?.tabText}
              </button>
            )
        )}
      </div>

      {/* CONTENT */}
      <div>
        {(() => {
          const activeTabData = tabs.find(
            tab => tab?.fields?.tabText === activeTab
          )
          return (
            activeTabData &&
            (activeTabData?.fields?.components || []).map(
              (component, componentIndex) => (
                <Section
                  key={
                    component?.sys?.id ||
                    `active-${componentIndex}-${component?.fields?.title || "item"}`
                  }
                  fields={component?.fields}
                  sys={component?.sys}
                  position={componentIndex}
                />
              )
            )
          )
        })()}
      </div>
    </>
  )
}

ContentTabs.propTypes = {
  tabs: PropTypes.array,
  components: PropTypes.array,
}

export default ContentTabs
